(function () {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(track) {
    const autoplay = track.dataset.autoplay === 'true';
    const speed = Number(track.dataset.speed || 4); // 1-10
    if (!autoplay || prefersReduced) return;

    // px/frame: más speed => más rápido (muy suave)
    const step = 0.25 + (speed * 0.08);

    let rafId = null;
    let paused = false;

    const onPause = () => { paused = true; };
    const onResume = () => { paused = false; };

    track.addEventListener('mouseenter', onPause);
    track.addEventListener('mouseleave', onResume);
    track.addEventListener('focusin', onPause);
    track.addEventListener('focusout', onResume);
    track.addEventListener('touchstart', onPause, { passive: true });
    track.addEventListener('touchend', onResume);

    function tick() {
      if (!paused) {
        const max = track.scrollWidth - track.clientWidth;
        if (max <= 0) {
          rafId = requestAnimationFrame(tick);
          return;
        }
        const next = track.scrollLeft + step;

        // loop suave
        track.scrollLeft = (next >= max - 1) ? 0 : next;
      }
      rafId = requestAnimationFrame(tick);
    }

    rafId = requestAnimationFrame(tick);

    // cleanup si Shopify re-renderiza
    const observer = new MutationObserver(() => {
      if (!document.body.contains(track) && rafId) cancelAnimationFrame(rafId);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-logo-carousel]').forEach(init);
  });

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-logo-carousel]').forEach(init);
  });
})();